import { config } from '../config';
import { getBrandContent } from './brands';

export default function useBrand() {
  return getBrandContent(config.brand);
}
